import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import selectAnalytics from './selectAnalytics';
import Price from '../Product/Price';
import { updateListItemCache } from '../../actions/checkout';
import { searchInput } from '../../actions/environment';
import { productImageSizeTranslation } from '../../utils/image';
import { translate, prefix, translateObjectData, removeLanguagePrefix } from '../../utils/locale';
import s from './ProductItem.scss';

const ProductItem = ({ content, setup, currentPath, currentHash, currentView, canonical, searchInputText, imageSize, itemIndex = 1, variation = '', ...props }) => {
	content = translateObjectData(setup, content);
	const productItemClasses = [s.productItem, 'u_productItem'];
	const path = canonical ? translate(setup, content, 'canonicalUri') : `${currentPath}/${content.uri}${currentHash}`;
	const discount = content.price.discountPercent || (100 - Math.round((content.price.priceAsNumber / content.price.priceBeforeDiscountAsNumber) * 100));

	if (!content || content.productHidden) return null;

	const productItemSelected = () => {
		selectAnalytics(content, setup, currentView, itemIndex);
		props.updateListItemCache(content.groupId, removeLanguagePrefix(currentView));
	};

	if (!content.inStock) productItemClasses.push(s.productItem__soldOut);
	if (content.price.showAsOnSale) productItemClasses.push(s.productItem__sale);
	if (content.price.newProduct) productItemClasses.push(s.productItem__new);
	if (variation) productItemClasses.push(s[`productItem__${variation}`]);

	const badges = [];
	let newSet = false;
	let saleSet = false;

	if (content.badges) {
		Object.keys(content.badges).forEach((badge) => {
			if (!!content.badges[badge].isNew && !content.price.newProduct) return;
			if (!!content.badges[badge].isNew && content.price.newProduct) newSet = true;
			if (!!content.badges[badge].isSale && !content.price.showAsOnSale) return;
			if (!!content.badges[badge].isSale && content.price.showAsOnSale) saleSet = true;
			if (!!content.badges[badge].isSoldOut && content.inStock) return;
			if (content.badges[badge].image) {
				badges.push(<span key={badge} className={[s.productItem_badge, s.productItem_badge__svg].join(' ')}><img src={content.badges[badge].image.url} alt="" /></span>);
			}
		});
	}

	if (content.inStock && content.price.newProduct && !newSet) {
		badges.unshift(<span key="new-badge" className={[s.productItem_badge, s.productItem_badge__new].join(' ')}>{ translate(setup, 'new') }</span>);
	} else if (content.inStock && content.price.showAsOnSale && !saleSet) {
		badges.unshift(<span key="sale-badge" className={[s.productItem_badge, s.productItem_badge__sale].join(' ')}>{ discount }%</span>);
	}

	return (
		<div className={productItemClasses.join(' ')} data-product-id={content.groupId} data-product-index={itemIndex}>
			<Link className={s.productItem_link} to={prefix(setup, path)} onClick={productItemSelected}>
				<div className={s.productItem_badges}>
					{ badges }
				</div>
				<div className={s.productItem_images}>
					{
						content.image.map((image) => (image && <img key={image.slice(image.lastIndexOf('/') + 1)} {...productImageSizeTranslation(imageSize, image)} alt={`${content.brand} ${content.name}`} />))
					}
				</div>
				<div className={s.productItem_text}>
					<span className={s.productItem_text_brand}>{ content.brand }</span>
					<span className={s.productItem_text_name}>{ content.name } — { content.variantName }</span>
					<div className={s.productItem_text_price}>
						<Price price={content.price} soldOut={!content.inStock ? translate(setup, 'soldOut') : false} />
					</div>
				</div>
			</Link>
		</div>
	);
};

const mapState = ({ environment }, { content, id, currentPath, variation }) => ({
	setup: environment.setup,
	content,
	id,
	currentPath,
	variation,
});

export default hot(module)(connect(mapState, { searchInput, updateListItemCache })(ProductItem));
